import { render, staticRenderFns } from "./income.vue?vue&type=template&id=4e456805&scoped=true&"
import script from "./income.vue?vue&type=script&lang=js&"
export * from "./income.vue?vue&type=script&lang=js&"
import style0 from "./income.vue?vue&type=style&index=0&lang=css&"
import style1 from "./income.vue?vue&type=style&index=1&id=4e456805&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e456805",
  null
  
)

export default component.exports